<!-- 场馆漫游 -->
<template>
    <div class="listcontainer">
        <slot></slot>        
        <div :class="isMobile?'mlayout':'layout'" v-if="isMobile">
            <div class="header">
                <span class="title">景点列表</span>
            </div>
           <div class="scenesC">
                <Swiper :options="swiperOption2">
                    <SwiperSlide v-for="(item,i) in scenes" :key="i" class="swiper-slide">
                        <div :class="['bg',i==mcur?'active':'']">
                            <img :src="item.img" alt="" @click="$router.push({name:'Pano',query:{id:item.id}})">
                            <!-- <img v-if="i==mcur" :src="item.imghover" alt="" @click="$router.push({name:'Pano',query:{id:item.id}})">
                            <img v-else :src="item.img" alt="" @click="$router.push({name:'Pano',query:{id:item.id}})"> -->
                        </div>            
                    </SwiperSlide>
                </Swiper>
               
           </div>                     
        </div>
        <div :class="isMobile?'mlayout':'layout'" v-else>
            <div class="header">
                <span class="title">景点列表</span>
            </div>
           <div class="scenesC">
                <Swiper :options="swiperOption">
                    <SwiperSlide v-for="(item,i) in scenes" :key="i" class="swiper-slide">
                        <div :class="['bg',i==cur?'active':'']" @mouseover="showActive(i)">
                            <img :src="item.img" alt="" @click="$router.push({name:'Pano',query:{id:item.id}})">
                            <!-- <img v-if="i==cur" :src="item.imghover" alt="" @click="$router.push({name:'Pano',query:{id:item.id}})">
                            <img v-else :src="item.img" alt="" @click="$router.push({name:'Pano',query:{id:item.id}})"> -->
                        </div>            
                    </SwiperSlide>
                </Swiper>
                <span class="btn left"><img src="@/assets/images/left.png" alt=""></span>
                <span class="btn right"><img src="@/assets/images/right.png" alt=""></span>
           </div>                     
        </div>
       
       
    </div>

</template>

<script>
    //这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
    //例如：import 《组件名称》 from '《组件路径》';
    import browser from '@/utils/browser.js'
    import {
        Swiper,
        SwiperSlide
    } from "vue-awesome-swiper";
    import "swiper/css/swiper.css";
    export default {
        //import引入的组件需要注入到对象中才能使用
        components: {
            Swiper,
            SwiperSlide,
        },
        data() {
            //这里存放数据
            return {
                isMobile: browser.mobile,
                cur: 3,
                mcur:0,
                hoverIndex:-1,
                scenes: [
                    {
                        name: '红井',
                        id:1,
                        intro: '',
                        pano: '1231',
                        img: require('../../assets/images/scenes/红井.png'),
                        imghover: require('../../assets/images/scenes/active/红井.png'),
                        

                    },{
                        name: '瑞金纪念馆',
                        id:2,
                        intro: '',
                        pano: '1167',
                        img: require('../../assets/images/scenes/瑞金纪念馆.png'),
                        imghover: require('../../assets/images/scenes/active/瑞金纪念馆.png'),

                    },{
                        id:3,
                        name: '沙洲坝中华苏维埃共和国中央人民委员会旧址',
                        intro: '',
                        pano: '1214',
                        img: require('../../assets/images/scenes/沙洲坝中华苏维埃共和国中央人民委员会旧址.png'),
                        imghover: require('../../assets/images/scenes/active/沙洲坝中华苏维埃共和国中央人民委员会旧址.png'),

                    },{
                        name: '沙洲坝中华苏维埃共和国中央执行委员会旧址',
                        id:4,
                        intro: '',
                        pano: '1230',
                        img: require('../../assets/images/scenes/沙洲坝中华苏维埃共和国中央执行委员会旧址.png'),
                        imghover: require('../../assets/images/scenes/active/沙洲坝中华苏维埃共和国中央执行委员会旧址.png'),

                    },{
                        name: '叶坪博生堡',
                        id:5,
                        intro: '',
                        pano: '1219',
                        img: require('../../assets/images/scenes/叶坪博生堡.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪博生堡.png'),

                    },
                    {
                        name: '叶坪红军检阅台',
                        id:6,
                        intro: '',
                        pano: '1228_2',
                        img: require('../../assets/images/scenes/叶坪红军检阅台.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪红军检阅台.png'),

                    },{
                        name: '叶坪红军烈士纪念塔',
                        id:7,
                        intro: '',
                        pano: '1228_1',
                        img: require('../../assets/images/scenes/叶坪红军烈士纪念塔.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪红军烈士纪念塔.png'),

                    },
                    {
                        name: '叶坪红军烈士纪念亭',
                        id:8,
                        intro: '',
                        pano: '1222',
                        img: require('../../assets/images/scenes/叶坪红军烈士纪念亭.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪红军烈士纪念亭.png'),

                    },{
                        name: '叶坪红军无线电总队旧址',
                        id:9,
                        intro: '',
                        pano: '1224',
                        img: require('../../assets/images/scenes/叶坪红军无线电总队旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪红军无线电总队旧址.png'),

                    },
                    {
                        name: '叶坪公略亭',
                        id:10,
                        intro: '',
                        pano: '1216',
                        img: require('../../assets/images/scenes/叶坪公略亭.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪公略亭.png'),

                    },
                    {
                        name: '叶坪红色中华通讯社旧址',
                        id:11,
                        intro: '',
                        pano: '1123',
                        img: require('../../assets/images/scenes/叶坪红色中华通讯社旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪红色中华通讯社旧址.png'),

                    },{
                        name: '叶坪中国共产党苏维埃区域中央局旧址',
                        id:12,
                        intro: '',
                        pano: '1268',
                        img: require('../../assets/images/scenes/叶坪中国共产党苏维埃区域中央局旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中国共产党苏维埃区域中央局旧址.png'),

                    },{
                        name: '叶坪中华苏维埃共和国出版局旧址',
                        id:13,
                        intro: '',
                        pano: '1217',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国出版局旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国出版局旧址.png'),

                    },{
                        name: '叶坪中华苏维埃共和国国家银行旧址',
                        id:14,
                        intro: '',
                        pano: '1223',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国国家银行旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国国家银行旧址.png'),

                    },{
                        name: '叶坪中华苏维埃共和国临时中央政府电话总机室旧址',
                        id:15,
                        intro: '',
                        pano: '1226',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国临时中央政府电话总机室旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国临时中央政府电话总机室旧址.png'),

                    },{
                        name: '叶坪中华苏维埃共和国临时中央政府旧址',
                        id:16,
                        intro: '',
                        pano: '1225',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国临时中央政府旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国临时中央政府旧址.png'),

                    },{
                        name: '叶坪中华苏维埃共和国邮政局旧址',
                        id:17,
                        intro: '',
                        pano: '1233',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国邮政局旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国邮政局旧址.png'),

                    },{
                        name: '叶坪中华苏维埃共和国中央传令排旧址',
                        id:18,
                        intro: '',
                        pano: '1229',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国中央传令排旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国中央传令排旧址.png'),

                    },{
                        name: '叶坪中华苏维埃共和国中央革命军事委员会旧址',
                        id:19,
                        intro: '',
                        pano: '1227',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国中央革命军事委员会旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国中央革命军事委员会旧址.png'),

                    },{
                        name: '叶坪中华苏维埃共和国中央警卫营旧址',
                        id:20,
                        intro: '',
                        pano: '1221',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国中央警卫营旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国中央警卫营旧址.png'),

                    },{
                        name: '叶坪中华苏维埃共和国总金库旧址',
                        id:21,
                        intro: '',
                        pano: '1218',
                        img: require('../../assets/images/scenes/叶坪中华苏维埃共和国总金库旧址.png'),
                        imghover: require('../../assets/images/scenes/active/叶坪中华苏维埃共和国总金库旧址.png'),

                    }
                ]
            };
        },
        //监听属性 类似于data概念
        computed: {
            swiperOption() {
                var _this = this;
                return {
                    slidesPerView: 5,
                    spaceBetween: 30,
                    centeredSlides: true,
                    initialSlide: 3,
                    // centeredSlidesBounds: true,
                    // centerInsufficientSlides: true,
                    pagination: {
                        el: ".pagination",
                        type: "bullets",
                        clickable: true
                    },
                    navigation: {
                    nextEl: ".right",
                    prevEl: ".left",
                    },
                    // freeMode:true,
                    // normalizeSlideIndex: true,
                    // slideActiveClass : 'slide-active',
                    on: {
                        slideChange: function () {
                            console.log(this.activeIndex)
                            _this.cur = this.activeIndex;
                        }
                    },

                };
            },
            swiperOption2() {
                 var _this = this;
                return {
                    pagination: {
                        el: ".pagination",
                        type: "bullets",
                        clickable: true
                    },
                    effect: "coverflow",
                    slidesPerView: 3,
                    centeredSlides: true,
                    coverflowEffect: {
                    rotate: 30,
                    stretch: 0,
                    depth: 150,
                    modifier: 2,
                    slideShadows: false,
                    },
                    // freeMode:true,
                    // normalizeSlideIndex: true,
                    // slideActiveClass : 'slide-active',
                    on: {
                        slideChange: function () {
                            console.log(this.activeIndex);
                             _this.mcur = this.activeIndex;
                        }
                    },

                };
            },
        },
        //监控data中的数据变化
        watch: {},
        //方法集合
        methods: {
            showActive(i) {
                console.log("hover");
                console.log(i)
                this.hoverIndex = i;
            },
            goScene(id) {
                this.$router.push({
                    name: 'Scene',
                    query: {
                        id: id
                    }
                })
            },
            showScene(id, i) {
                if (i == this.cur) {
                    this.$router.push({
                        name: 'Scene',
                        query: {
                            id: id
                        }
                    })
                }
                this.cur = i;

            }
        },
        //生命周期 - 创建完成（可以访问当前this实例）
        created() {

        },
        //生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {

        },
        beforeCreate() {}, //生命周期 - 创建之前
        beforeMount() {}, //生命周期 - 挂载之前
        beforeUpdate() {}, //生命周期 - 更新之前
        updated() {}, //生命周期 - 更新之后
        beforeDestroy() {}, //生命周期 - 销毁之前
        destroyed() {}, //生命周期 - 销毁完成
        activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
    //@import url(); 引入公共css类
    .listcontainer {
        width: 100%;
        height: 100%;
    }
    .layout {
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-size: cover;

        .header {
            width: 100%;
            height: 8.33vw;
            margin-bottom: 6.77vw;
            text-align:center;

            .title {
                font-size: 24px;
                color: #fff;
                line-height: 8.33vw;
                border-bottom:2px dashed #fff;
                padding-bottom:10px;
                
            }
        }
      
        .scenesC {
            width:90%;
            margin:0 auto;
            .btn {
                border:none;
                outline:none;
                position:absolute;
                display:block;
                width:2.9vw;
                height:2.9vw;
                top:0;
                bottom:0;
                margin:auto;
                cursor:pointer;
                 &.left {               
                    left:1vw;                
                }
                &.right {               
                    right:1vw;                
                }
            }
           
        }
        .swiper-slide {
            cursor:pointer;
            .hover-info {
                position: absolute;
                top: 100%;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(152, 2, 4, 0.75);
                padding-top: 14vh;
                transition: all 1.5s;

                .name {
                    width: 18.75vw;
                    height: 4.6875vw;
                    margin: 0 auto;
                    border: 2px solid #ffde00;
                    color: #ffde00;
                    font-size: 3vw;
                    font-weight: bold;
                    text-align: center;
                    line-height: 4.6875vw;
                    border-radius: 0.5vw;
                }

                p {
                    font-size: 1.25vw;
                    line-height: 2vw;
                    color: #ffde00;
                    padding: 0 1vw;
                    text-indent: 2em;
                    margin-top: 10vh;
                    text-align: justify;
                }
            }

            &:hover {
                .hover-info {
                    top: 0;
                }
            }
        }

        .prev {
            position: absolute;
            z-index: 2;
            width: 2vw;
            height: 2vw;
            left: 1.56vw;
            top: 0;
            bottom: 0;
            margin: auto;
            outline: none;
            border: none;
            cursor:pointer;

            img {
                width: 100%;
            }
        }

        .next {
            position: absolute;
            z-index: 2;
            width: 2vw;
            height: 2vw;
            right: 1.56vw;
            top: 0;
            bottom: 0;
            margin: auto;
            outline: none;
            border: none;
            cursor:pointer;

            img {
                width: 100%;
            }
        }
         .swiper-slide {
        .bg {
            position:relative;
            text-align:center;
            transform:scale(0.9);
            transition:all 0.5s ease;
            &.active {
                transform:scale(1);
            }
            // &:hover {
                
            // }
           
            img {
                width:98%;
            }
            
            
        }
    }
    }
    .mlayout {
        width: 100%;
        height: 100%;
        overflow: hidden;
        background-size: cover;
        .header {
            width: 100%;
            height: 21.3vw;
            margin-bottom: 0;
            text-align:center;
            .title {
                font-size: 24px;
                color: #fff;
                line-height: 21.3vw;
                text-align: center;
                border-bottom:2px dashed #fff;
            }
        }
        .scenesC {
            width:98%;
            margin:0 auto;
        }
        .swiper-slide {
            width: 93vw;
            height: 134vw;
            max-height: 505px;
            display: flex;
            justify-content: center;
            align-content: center;
            .bg {
                img {
                    max-width:349px;
                    max-height:505px;
                    width: auto;
                    height: 134vw;
                }
            }
            
            .hover-info {
                position: absolute;
                top: 100%;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(152, 2, 4, 0.75);
                padding-top: 14vh;
                transition: all 1.5s;

                .name {
                    width: 18.75vw;
                    height: 4.6875vw;
                    margin: 0 auto;
                    border: 2px solid #ffde00;
                    color: #ffde00;
                    font-size: 3vw;
                    font-weight: bold;
                    text-align: center;
                    line-height: 4.6875vw;
                    border-radius: 0.5vw;
                }

                p {
                    font-size: 1.25vw;
                    line-height: 2vw;
                    color: #ffde00;
                    padding: 0 1vw;
                    text-indent: 2em;
                    margin-top: 10vh;
                    text-align: justify;
                }
            }

            &:hover {
                .hover-info {
                    top: 0;
                }
            }
        }

        .prev {
            position: absolute;
            z-index: 2;
            width: 2vw;
            height: 2vw;
            left: 1.56vw;
            top: 0;
            bottom: 0;
            margin: auto;
            outline: none;
            border: none;

            img {
                width: 100%;
            }
        }

        .next {
            position: absolute;
            z-index: 2;
            width: 2vw;
            height: 2vw;
            right: 1.56vw;
            top: 0;
            bottom: 0;
            margin: auto;
            outline: none;
            border: none;

            img {
                width: 100%;
            }
        }
    }

    

   

    .mlayout .swiper-slide {
        width: 90vw;
    }

    .pagination {
        text-align: center;
    }

    .mlayout .pagination {
        height: 2px;
        font-size: 0;
    }
</style>
<style>
    .pagination .swiper-pagination-bullet {
        width: 2vw;
        height: 2px;
        background: #b52223;
        margin: 0 5px;
    }
</style>